module.exports = __webpack_public_path__ + "img/More-service-image.dd3addd6.webp";